<template>
  <div class="container-form margin-top-30">
    <h4 class="section-name-form">Responsabil de corespondență</h4>
    <p
      class="section-description-form"
    >Alege persoana care va fi contactată de curier pentru livrarea contractului în format fizic</p>
    <div class="margin-top-30">
      <form-radio
        input-name="correspondence"
        :input-value="true"
        input-id="ownerName"  
        :input-label="ownerName"
        :setInput="setInput"
        :input-checked="isOwnerResponsibleCorresp"
      ></form-radio>
      <form-radio
        v-if="hasContact"
        input-name="correspondence"
        :input-value="false"
        input-id="contactName"
        :input-label="contactName"
        :setInput="setInput"
        :input-checked="!isOwnerResponsibleCorresp"
      ></form-radio>
    </div>
    <div class="align-button-form margin-top-30">
      <button-form button-name="PASUL URMĂTOR" :on-click="nextStep"></button-form>
    </div>
  </div>
</template>

<script>
import FormRadio from "../global/FormRadio";
import ButtonForm from "../global/ButtonForm";
import { mapState, mapMutations } from "vuex";

export default {
  components: {
    FormRadio,
    ButtonForm
  },
  computed: {
    ...mapState({
      hasContact: state => state.formInputs.hasContact,
      ownerName: state =>
        state.formInputs.firstName + " " + state.formInputs.lastName,
      contactName: state =>
        state.formInputs.contact.firstName +
        " " +
        state.formInputs.contact.lastName,
      isOwnerResponsibleCorresp: state =>
        state.formInputs.isOwnerResponsibleCorresp
    })
  },
  methods: {
    setInput: function(event) {
      if (this.isOwnerResponsibleCorresp !== (event.target.value === "true"))
        this.setIsOwnerResponsibleCorresp(event.target.value === "true");
    },
    nextStep: function() {
      this.incrementWizardStep();
    },
    ...mapMutations(["setIsOwnerResponsibleCorresp", "incrementWizardStep"])
  }
};
</script>

<style lang="scss" scoped>
p {
  font-size: 1rem;
}
</style>
